import React from 'react'
import {FaGithub, FaLinkedin} from 'react-icons/fa'
import {HiOutlineMail} from 'react-icons/hi'
import {BsFillPersonLinesFill} from 'react-icons/bs'


const SocialLinks = () => {

    const links = [
        {
            id:1,
            child: (
                <>
                LinkedIn <FaLinkedin size={30}/>
                </>
            ),
            href: 'https://linkedin.com',
            style: 'rounded-tr-md'
           
        },
        {
            id:2,
            child: (
                <>
                GitHub <FaGithub size={30}/>
                </>
            ),
            href: 'https://github.com/sammuthaiga',
            
           
        },
        {
            id:3,
            child: (
                <>
               Mail<HiOutlineMail size={30}/>
                </>
            ),
            href: 'mailto:foo@gmail.com',
            
           
        },
        {
            id:4,
            child: (
                <>
            Resume <BsFillPersonLinesFill size={30}/>
                </>
            ),
            href: 'resume.pdf',
            style: 'rounded-br-md',
            download: true,
           
        }
    ]
  return (
    <div className='hidden lg:flex flex-col top-[35%] left-0 fixed'>
        {links.map(({id, child, href, style, download}) => (
            // eslint-disable-next-line no-useless-concat
            <li key={id} className={'flex justify-between items-center w-40 h-14 px-4 ml-[-100px] hover:ml-[-10px] hover:rounded-md duration-300 bg-gray-500 visited:bg-white' + " " + style}>
            <a 
            href={href} 
            className='flex justify-between items-center w-full text-white'
            download={download}
            rel="noreferrer"
            target='_blank' 
            >
            {child}
            </a> 
            </li>

        ))}
        <ul>
            
        </ul>
    </div>
  )
}

export default SocialLinks